export default {
  filter: {
    users: {
      placeholder: 'Select User'
    },
    status: {
      placeholder: 'All statuses'
    }
  },
  table: {
    amount: 'Amount',
    generated_for: 'Generated For',
    status: 'Status',
    plan: 'Plan',
    due_at: 'Due At',
    actions: {
      title: 'Actions',
      tooltip: {
        view_details: 'View Details',
        pay_invoice: 'Pay invoice'
      }
    },
    created_at: 'Created At',
    invoice_id: 'Invoice ID'
  },
  buttons: {
    pay_invoice: 'Pay Invoice',
    change_payment_method: 'Change payment method'
  },
  invoice_details: {
    title: 'Invoice Details',
    general_info: {
      title: 'General Info',
      fields: {
        invoice_id: 'Invoice ID',
        generated_at: 'Generated At',
        generated_for: 'Generated For',
        amount: 'Amount',
        payment_id: 'Payment ID',
        paid_at: 'Paid At',
        status: 'Status'
      }
    },
    payment_info: {
      title: 'Payment Info',
      fields: {
        payment_card: 'Payment Card'
      }
    },
    buttons: {
      close: 'Close'
    }
  }
};